import { render, staticRenderFns } from "./SignUpIcon3.vue?vue&type=template&id=e34b0ae6"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e34b0ae6')) {
      api.createRecord('e34b0ae6', component.options)
    } else {
      api.reload('e34b0ae6', component.options)
    }
    module.hot.accept("./SignUpIcon3.vue?vue&type=template&id=e34b0ae6", function () {
      api.rerender('e34b0ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SignUpIcon3.vue"
export default component.exports